import { CloseOutlined, DownOutlined, RightOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, message, Space, Table } from "antd";
import { serverFetch } from "@server";
import { renderCheckbox } from "@extensions/helper";
import CompanyBaseItem from "./company-base-item";

const CompanyBase = ({ id, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState();
  const [users, setUsers] = useState([]);
  const [form] = Form.useForm();
  const [selected, setSelected] = useState(null);

  const getData = () => {
    setLoading(true);
    serverFetch(`db/${id}`)
      .then(data => {
        setItem(data);
        setLoading(false);
        setUsers((data.scheme.factory.users ?? []).map((item,idx) => ({...item, id: idx + 1 })));
        form.setFieldsValue(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [form, id]);

  // Изменение item
  const onValuesChange = value => setItem({...item, ...value})

  const onSave = () => {
    setLoading(true);
    serverFetch("db", { method: "PUT", bodyData: {...item, scheme: {...item.scheme, factory: {...item.scheme.factory, users } }}})
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onCancel = () => onClose(false);

  const onChangeDiler = value => setItem({...item, scheme: {...item.scheme, diler: {...item.scheme.diler, ...value } } })

  const onChangeFactory = value => setItem({...item, scheme: {...item.scheme, factory: {...item.scheme.factory, ...value } } })

  const columns = [
    Table.SELECTION_COLUMN,
    { dataIndex: "id", },
    { title: "Акт.", dataIndex: "isAct", render: renderCheckbox, align: "center", },
    { title: "Пользователь", dataIndex: "name", },
    { title: "Настройки", dataIndex: "isNstr", render: renderCheckbox, align: "center",  },
    { title: "Коэфф.", dataIndex: "coeff", align: "center", },
    { title: "Пакеты", dataIndex: "isPack", render: renderCheckbox, align: "center", },
    { title: "С отдела", dataIndex: "depnoOld", align: "center", },
    { title: "На отдел", dataIndex: "depnoNew", align: "center", },
    { title: "Комментарий", dataIndex: "comment", },
    Table.EXPAND_COLUMN,
  ]

  const onRowClick = id => selected === id ? setSelected(null) : setSelected(id)

  const onItemClose = newItem => {
    setSelected(null);
    if (newItem) {
      if (newItem.id)
        setUsers(users.map(item => item.id === newItem.id ? newItem : item))
      else
        setUsers([
          ...users.filter(item => item.id), 
          {...newItem, id: users.length > 1 ? (users[users.length - 2].id + 1) : 1 }
        ]);
    }
  }

  const onItemAdd = () => {
    setUsers([...users.filter(i => i.id), { id: 0 }]);
    setSelected(0);
  }

  const onItemDelete = id => setUsers(users.filter(i => i.id !== id))

  return<div>
    <div className="misoft-modal-overlay" onClick={e => e.target === e.currentTarget && onClose(false)}>
      <div className="misoft-modal-content" style={{width: 800}}>
        <div className="misoft-modal-title">
          <span>База</span>
          <CloseOutlined
            className="misoft-section-title-close" 
            onClick={() => onClose()} style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}                
          />
        </div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading} style={{maxWidth: 800}}>
          <Form.Item label="Наименование" name="name"><Input /></Form.Item>
          <Form.Item label="Удалена" name="isDel" valuePropName="checked"><Checkbox /></Form.Item>
          <Form.Item label="Код базы" name="guid"><Input /></Form.Item>
          <Form.Item label=' '><div><strong>ДИЛЕР</strong></div></Form.Item>
          <Form.Item label="Получать настройки">
            <Input placeholder="Телефон +7XXXXXXXXXX или почта" value={item?.scheme.diler.nstr} 
              onChange={e => onChangeDiler({ nstr: e.target.value })} />
          </Form.Item>
          <Form.Item label="Отправлять пакеты">
            <Input placeholder="Телефон +7XXXXXXXXXX или почта" value={item?.scheme.diler.pack} 
              onChange={e => onChangeDiler({ pack: e.target.value })}  />
          </Form.Item>
          <Form.Item label=' '><div><strong>ПРОИЗВОДИТЕЛЬ / ПОСТАВЩИК</strong></div></Form.Item>
          <Form.Item label=" "><Checkbox checked={item?.scheme.factory.defaultLoad} onChange={e => onChangeFactory({defaultLoad: e.target.checked })}>Предоставлять настройки всем пользователям</Checkbox></Form.Item>
          <Form.Item label="Коэфф. прайса по умолч.">
            <Input style={{maxWidth: 100}} value={item?.scheme.factory.defaultCoeff} onChange={e => onChangeFactory({defaultCoeff: e.target.value })} />
          </Form.Item>
          <Form.Item label=" "><div><strong>ДИЛЕРЫ</strong></div></Form.Item>
          <Form.Item label=""><Button onClick={onItemAdd}>Добавить</Button></Form.Item>
          <Table columns={columns} dataSource={users} rowKey="id" pagination={false} loading={loading} size="small"
            expandable={{
              expandedRowRender: (record) => <CompanyBaseItem onClose={onItemClose} itemDefault={record} onDelete={onItemDelete}/>, expandedRowKeys: [selected],
              onExpand: (expanded, record) => setSelected(expanded ? [record.id] : []),
              expandIcon: ({ expanded, onExpand, record }) => expanded ? 
                <DownOutlined onClick={(e) => onExpand(record, e)} /> : 
                <RightOutlined onClick={(e) => onExpand(record, e)} />,
              rowExpandable: () => true,
            }}
            onRow={record => ({ onClick: () => onRowClick(record.id) })}
            rowSelection={{ type: 'radio', selectedRowKeys: [selected], renderCell: checked => <div className={checked ? "misoft-list-indicator" : ""} /> }}
          />
          <Form.Item />
          <Form.Item label=" "><Space>
            <Button className="misoft-btn" onClick={onSave}>Сохранить</Button>
            <Button className="misoft-btn" onClick={onCancel}>Отмена</Button>
          </Space></Form.Item>
        </Form>
      </div>
    </div>
  </div>
}

export default CompanyBase;